import React from 'react';
import CMS from '../../cms/cms.json';
import { Flex, Card } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import styles from './VendorAdminHome.module.css';

export function VendorAdminHome() {
  const navigate = useNavigate();

  return (
    <div className={`main-body ${styles['main-body-offset']}`}>
      <div className={styles['card-panel']}>
        <div className={styles['title-row']}>
          <h2>{CMS.pages.find((o) => o.name === 'vendorAdmin')?.title}</h2>
        </div>
        <Flex direction={'row'} marginTop={'80px'}>
          <Card
            className="menu-card"
            onClick={() => navigate('/create-vendor')}
          >
            <AddShoppingCartOutlinedIcon
              fontSize="large"
              className={styles['icon-spacing']}
            />
            <Flex
              direction={'column'}
              justifyContent={'space-around'}
              alignItems={'flex-start'}
            >
              <b>{CMS.pages.find((o) => o.name === 'createVendor')?.title}</b>
              <p className={styles['card-description']}>
                {CMS.text.find((o) => o.name === 'createVendorCard')?.title}
              </p>
            </Flex>
          </Card>

          <Card
            className="menu-card"
            onClick={() => navigate('/manage-vendor')}
          >
            <ShoppingCartOutlinedIcon
              fontSize="large"
              className={styles['icon-spacing']}
            />
            <Flex
              direction={'column'}
              justifyContent={'space-around'}
              alignItems={'flex-start'}
            >
              <b>{CMS.pages.find((o) => o.name === 'manageVendors')?.title}</b>
              <p className={styles['card-description']}>
                {CMS.text.find((o) => o.name === 'manageVendorCard')?.title}
              </p>
            </Flex>
          </Card>
        </Flex>
      </div>
    </div>
  );
}
